import React, { useState } from 'react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';

const PillarDropDown = ({
  options,
  setFieldValue,
  setFieldTouched,
  name,
  onClick,
  selectedOption = {},
}) => {
  const [showAvailableOptions, setShowAvailableOptions] = useState(false);

  const toggleAvailableOptions = () => {
    setShowAvailableOptions(!showAvailableOptions);
  };
  const closeOptions = (option) => {
    if (setFieldValue && name) {
      setFieldValue(name, option);
    }
    if (setFieldTouched && name) {
      setFieldTouched(name, true);
    }
    onClick(option);
    toggleAvailableOptions();
  };

  return (
    <div className="pillar-dropdown">
      <div
        className="pillar-dropdown__trigger-wrapper"
        onClick={toggleAvailableOptions}
      >
        <div
          className="pillar-dropdown__trigger"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            border: '2px solid #DEEDF2',
            borderRadius: '4px',
            padding: '8px',
            margin: 0,
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          {selectedOption.name ? (
            selectedOption.name
          ) : (
            <span>Selecciona un pilar</span>
          )}
          <span className="material-symbols-outlined">expand_more</span>
        </div>
      </div>
      {showAvailableOptions && (
        <FormControl
          className="pillar-dropdown__menu"
          name=""
          component="fieldset"
        >
          <FormGroup>
            {options.map((option) => (
              <FormControlLabel
                className="pillar-dropdown__option"
                key={option.id}
                control={
                  <Checkbox
                    style={{ color: '#38bdf8' }}
                    checked={selectedOption.id === option.id}
                    value={option.name}
                    name={option.name}
                    onChange={() => closeOptions(option)}
                  />
                }
                label={option.name}
              />
            ))}
          </FormGroup>
        </FormControl>
      )}
    </div>
  );
};

export default PillarDropDown;
